import Vue from 'vue';
import { LoadingService } from '@/services';
import { EventBus } from '@/event-bus/index';
import { getContentArea } from '@/contentful';
import { s3Instance } from '@/services';
import { FileUtils } from '@/helpers';

export default Vue.extend({
  data() {
    return {
      memberId: this.$store.getters.user.memberId,
    };
  },
  methods: {
    openViewAttachmentScreen(params) {
      const IS_DISPLAYABLE = FileUtils.isDisplayable(
        params.attachment.fileName,
      );
      const PROMISES = [getContentArea('view-attachment-error')];
      if (IS_DISPLAYABLE) {
        const EXTENSION = FileUtils.getFilenameExtension(
          params.attachment.fileName,
        );
        const uuidExtension = FileUtils.getFilenameExtension(
          params.attachment.uuid,
        );
        if (!uuidExtension) {
          PROMISES.push(
            s3Instance.getFile(
              FileUtils.concatFilename(params.attachment.uuid, EXTENSION),
            ),
          );
        } else if (uuidExtension) {
          PROMISES.push(s3Instance.getFile(params.attachment.uuid));
        }
      }
      LoadingService.watchPromises(PROMISES)
        .then((data) => {
          const CONTENT_AREAS = data[0];
          const FILE = data[1];
          let paramsObj: any = {};
          if (CONTENT_AREAS && CONTENT_AREAS.fields) {
            paramsObj.errorMessage = CONTENT_AREAS.fields.content;
          }
          if (FILE) {
            paramsObj.file = FILE;
          }
          paramsObj = Object.assign(paramsObj, params);
          EventBus.$emit('openOverlayWrapper', 'ViewAttachment', paramsObj);
        })
        .catch((error) => {
          const errorModalConfig = {
            message: 'global_connection-error',
          };
          if (error.response.status !== 404) {
            Object.assign(errorModalConfig, {
              action: {
                label: 'global_try-again',
                performAction: () => {
                  this.openViewAttachmentScreen(params);
                },
              },
            });
          }
          EventBus.$emit('pageLoadFinish');
          EventBus.$emit('openModal', 'Error', errorModalConfig);
        });
    },
  },
});
